<!--
 * @FileDescription: 实时监控=》实时监控页面，某个安全帽的历史记录视频组件
 -->
<template>
  <!--历史记录视频组件 -->
  <div class="video-play-main" v-if="videoShow">
    <div class="video-play-title ">
      <!-- <i class="back-icon icon16" @click="returnList"></i> -->
      <div class="name">
        <span :title="videoName">
          {{ videoName | ellipsis }}
        </span>
        <span class="fz12 time">
          {{ videoTime }}
        </span>
      </div>
      <el-popover placement="top" trigger="click">
        <table class="video-info-table">
          <tbody>
            <tr>
              <td class="video-info-td video-info-td100 video-info-title" colspan="2">
                {{ $t('VideoProperties') }}
              </td>
            </tr>
            <tr>
              <td class="video-info-td video-info-td25">{{ $t('fileSizeH') }}</td>
              <td class="video-info-td video-info-td25">{{ videoInfo.fileSize }}MB</td>
            </tr>
            <tr>
              <td class="video-info-td video-info-td25">{{ $t('BitRate') }}</td>
              <td class="video-info-td video-info-td25">{{ videoInfo.videoBitRate }}kbps</td>
            </tr>
            <tr>
              <td class="video-info-td video-info-td25">{{ $t('Frames') }}</td>
              <td class="video-info-td video-info-td25">{{ videoInfo.videoFrameRate }}{{ $t('FramesSec') }}</td>
            </tr>
            <tr>
              <td class="video-info-td video-info-td25">{{ $t('widthH') }}</td>
              <td class="video-info-td video-info-td25">
                {{ videoInfo.videoWidth }}
              </td>
            </tr>
            <tr>
              <td class="video-info-td video-info-td25">{{ $t('widthH') }}</td>
              <td class="video-info-td video-info-td25">
                {{ videoInfo.videoHeight }}
              </td>
            </tr>
          </tbody>
        </table>

        <i slot="reference" class="imp-icon icon20" @click="_videoInfo" v-show="!tabType"></i>
      </el-popover>
      <!-- <span v-show="!tabType">{{ $t('importantH') }}：</span> -->
      <!-- <el-checkbox v-model="impFlag" class="importantCheck" v-show="!tabType"></el-checkbox> -->
      <!-- <i class="last-icon icon20" @click="prevVideo"></i> -->
      <!-- <i class="next-icon icon20" @click="nextVideo"></i> -->
      <i class="speed-back-icon icon20" title="慢放" @click="changeSpeedLow"></i>
      <i class="speed-to-icon icon20" :title="$t('fastForward')" @click="changeSpeedHight"></i>
      <span>×</span>
      <span>{{ playbackRate }}</span>
      <span class="turn-box">
        <i class="trans-icon" title="旋转" @click="handleVideo"></i>
      </span>
      <!-- <span class="ml10">轨迹：</span>
      <input value="true" type="checkbox" class="importantCheck" /> -->
      <div class="resolution" v-show="!tabType">
        <span
          :class="[isLowResolution ? 'resolution-low hightLight' : 'resolution-low']"
          @click="trggerResolution(true)"
          >{{ $t('fluent') }}</span
        >
        <span
          :class="[!isLowResolution ? 'resolution-hight hightLight' : 'resolution-hight']"
          @click="trggerResolution(false)"
          >{{ $t('highDefinition') }}</span
        >
      </div>
    </div>
    <div class="video-play-contain">
      <video
        v-if="videoSrcPlay"
        :src="videoSrcPlay"
        autoplay="autoplay"
        class="video-player"
        :class="turnAround ? 'handleVideo' : 'noTurn'"
        controls="controls"
        ref="video"
      ></video>
      <div v-else class="play-tip">{{ playTip }}</div>
    </div>
  </div>
</template>

<script>
import { isImportantFlag, videoInfo } from '@/api/log/video'
import { success } from '@/api/common'
import { saveVideo } from '@/util/historyVideo'
export default {
  props: {
    videoSrcArr: {
      type: Array,
    },
    index: {
      type: Number,
    },
    videoShow: {
      type: Boolean,
      default: false,
    },
    tabType: {
      type: String,
    },
    userData: {
      type: Object,
    },
  },
  data() {
    return {
      isLowResolution: true,
      playbackRate: 1,
      playbackRateLevel: 1,
      // 拷贝后的index 用于修改下一个视频
      cpIndex: '',
      videoSrcArrCopy: '',
      // 播放视频地址
      videoSrcPlay: '',
      // 视频属性参数
      videoInfo: {
        fileSize: '',
        videoBitRate: '',
        videoFrameRate: '',
        videoWidth: '',
        videoHeight: '',
      },
      // 是否翻转视频，默认不翻转
      turnAround: false,
      playTip: '',
    }
  },
  computed: {
    impFlag: {
      get() {
        if (this.videoSrcArrCopy[this.cpIndex]) {
          return this.videoSrcArrCopy[this.cpIndex].importantFlag
        } else {
          return ''
        }
      },
      set(newval) {
        let param = {
          importantFlag: newval,
          logTimestamp: this.videoSrcArrCopy[this.cpIndex].logTimestamp,
          type: 1,
          userId: this.videoSrcArrCopy[this.cpIndex].userId,
        }
        isImportantFlag(param).then(res => {
          if (res.state === 0) {
            success(this.$t('SettingSucceeded'))
            this.returnList()
            this.$emit('searchList')
          }
        })
      },
    },
    videoName() {
      if (this.videoSrcArrCopy[this.cpIndex] && this.videoSrcArrCopy[this.cpIndex].name) {
        return this.videoSrcArrCopy[this.cpIndex].name
      } else {
        return ''
      }
    },
    videoTime() {
      if (this.videoSrcArrCopy[this.cpIndex]) {
        return this.videoSrcArrCopy[this.cpIndex].endTime
      } else {
        return ''
      }
    },
  },
  methods: {
    handleVideo() {
      this.turnAround = !this.turnAround
    },
    // 请求视频属性
    _videoInfo() {
      let val = this.videoName
      if (this.isLowResolution) {
        val = val.replace(/.mp4/, '.low.mp4')
      }
      let param = {
        fileName: val,
      }
      videoInfo(param).then(res => {
        if (res.state === 0) {
          this.videoInfo = res.value.videoInfo
          this.videoInfo.fileSize = (res.value.fileSize / (1024 * 1024)).toFixed(2)
        }
      })
    },
    returnList() {
      this.$emit('update:videoShow', false)
      this.playbackRate = 1
      // 解决刷新
      this.$emit('searchList')
    },
    // 切换分辨率
    trggerResolution(type) {
      this.isLowResolution = type
      if (this.isLowResolution) {
        if (this.videoSrcArrCopy[this.cpIndex]) {
          if (this.videoSrcArrCopy[this.cpIndex].mediaLowUrl) {
            this.videoSrcPlay = this.videoSrcArrCopy[this.cpIndex].mediaLowUrl
          }
        }
      } else {
        this.videoSrcPlay = this.videoSrcArrCopy[this.cpIndex].mediaUrl
      }
    },
    // 下一个视频
    nextVideo() {
      if (this.cpIndex >= this.videoSrcArrCopy.length - 1) {
        this.cpIndex = 0
      } else {
        this.cpIndex += 1
      }
      this.playbackRate = 1
    },
    // 上一个视频
    prevVideo() {
      if (this.cpIndex === 0) {
        this.cpIndex = this.videoSrcArrCopy.length - 1
      } else {
        this.cpIndex -= 1
      }
      this.playbackRate = 1
    },

    // 快进
    changeSpeedHight() {
      if (this.playbackRateLevel !== 5) {
        this.playbackRateLevel = this.playbackRateLevel + 1
      }
      switch (this.playbackRateLevel) {
        case 1:
          this.playbackRate = 1
          break
        case 2:
          this.playbackRate = 1.5
          break
        case 3:
          this.playbackRate = 2
          break
        case 4:
          this.playbackRate = 4
          break
        case 5:
          this.playbackRate = 8
          break
      }
      this.$refs.video.playbackRate = this.playbackRate
    },
    // 慢放
    changeSpeedLow() {
      if (this.playbackRateLevel !== 0) {
        this.playbackRateLevel = this.playbackRateLevel - 1
      }
      switch (this.playbackRateLevel) {
        case 0:
          this.playbackRate = 0.5
          break
        case 1:
          this.playbackRate = 1
          break
        case 2:
          this.playbackRate = 1.5
          break
        case 3:
          this.playbackRate = 2
          break
        case 4:
          this.playbackRate = 4
          break
        case 5:
          this.playbackRate = 8
          break
      }
      this.$refs.video.playbackRate = this.playbackRate
    },
  },
  mounted() {
    // 自动播放下一条
    let that = this
    if (this.$refs.video) {
      this.$refs.video.onended = function() {
        if (that.cpIndex >= that.videoSrcArrCopy.length - 1) {
          that.cpIndex = 0
        } else {
          that.cpIndex += 1
        }
        that.playbackRate = 1
      }
    }
  },
  destroyed() {
    this.returnList()
  },
  watch: {
    index: {
      handler(val, old) {
        console.log(val, 'index')
        if (this.index !== null) {
          this.playbackRateLevel = 1
          this.cpIndex = this.index
          console.log(this.videoSrcArrCopy, 'index')
          if (this.videoSrcArrCopy.length > 0) {
            console.log(this.videoSrcArrCopy[this.index], 'index')
            this.videoSrcPlay = this.videoSrcArrCopy[this.index].mediaUrl
            console.log(this.videoSrcPlay, 'this.videoSrcPlayindex')
            if (this.userData.deviceName && this.videoSrcArrCopy[this.index]) {
              saveVideo(this.userData.deviceName, this.videoSrcArrCopy[this.index])
            }

            // 判断是执法仪 并且序列号含有‘0200’天一执法仪
            if (
              this.videoSrcArrCopy[this.index].helmetId.indexOf('ZFY0200') !== -1 &&
              this.videoSrcArrCopy[this.index].name.indexOf('cr_') !== -1
            ) {
              // 如果是执法仪，则默认顺时针旋转视频90度
              this.turnAround = true
            }
          }
        }
      },
      immediate: true,
    },
    cpIndex() {
      if (this.videoSrcArrCopy[this.cpIndex]) {
        this.playbackRateLevel = 1
        this.videoSrcPlay = this.videoSrcArrCopy[this.cpIndex].mediaUrl
        if (this.userData.deviceName && this.videoSrcArrCopy[this.cpIndex]) {
          saveVideo(this.userData.deviceName, this.videoSrcArrCopy[this.cpIndex])
        }
        if (
          this.videoSrcArrCopy[this.cpIndex].helmetId.indexOf('ZFY0200') !== -1 &&
          this.videoSrcArrCopy[this.cpIndex].name.indexOf('cr_') !== -1
        ) {
          console.log(this.videoSrcArrCopy[this.cpIndex].helmetId)
          // 如果是执法仪，则顺时针旋转视频90度
          this.turnAround = true
        }
        if (!this.videoSrcArrCopy[this.cpIndex].uploadFlag) {
          this.playTip = this.$t('videoVotUploaded')
        } else if (this.videoSrcArrCopy[this.cpIndex].status === 1) {
          this.playTip = this.$t('videoDeleted')
        }
      }
      // 如果地址为null 标签会沿用上一个视频的地址
      this.videoSrcPlay = this.videoSrcPlay === null ? '' : this.videoSrcPlay
    },
    videoSrcArr: {
      handler(newval, old) {
        this.videoSrcArrCopy = newval
        if (this.videoSrcArrCopy.length > 0) {
          console.log(this.videoSrcArrCopy[this.index], 'index')
          this.videoSrcPlay = this.videoSrcArrCopy[this.index].mediaUrl
          console.log(this.videoSrcPlay, 'shipin')
          // 判断是执法仪 并且序列号含有‘0200’天一执法仪
          if (
            this.videoSrcArrCopy[this.index].helmetId.indexOf('ZFY0200') !== -1 &&
            this.videoSrcArrCopy[this.index].name.indexOf('cr_') !== -1
          ) {
            // 如果是执法仪，则默认顺时针旋转视频90度
            this.turnAround = true
          }
        }
      },
      immediate: true,
    },
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'

.video-play-main
  width 100%
  height calc(100% - 40px)
  background-color: #fff;
  .handleVideo
    -webkit-transform rotate(-180deg)
  .noTurn
    -webkit-transform rotate(0deg)
  // 播放操作栏控制
  .handleVideo::-webkit-media-controls-enclosure
    -webkit-transform rotate(-180deg)
  .handleVideo::-webkit-media-controls-volume-control-container
    display none !important
  // 当前播放时间
  .handleVideo::-webkit-media-controls-current-time-display
    display block !important
  // 剩余时间
  .handleVideo::-webkit-media-controls-time-remaining-display
    display block !important
  .video-play-title
    display flex
    align-items center
    padding 8px 0px
    border: var(--table-border)
    color: var(--black-color);
    .name
      display flex
      flex-direction column
      margin-left 5px
      .time
        color var(--video-time-color)
    .importantCheck
      margin-right 10px
    .back-icon
      cursor pointer
      margin-left 10px
      bg-image('~@/icon/ic_back.png')
    .imp-icon
      margin-left 20px
      margin-right 10px
      bg-image('~@/icon/imp.png')
    .last-icon
      cursor pointer
      bg-image('~@/icon/last_one.png')
      margin 0 5px
    .next-icon
      cursor pointer
      margin 0 5px
      bg-image('~@/icon/next_one.png')
    .turn-box
      position: relative
      display: inline-block
      width 20px
      height: 20px
      border 1px solid #0565de
      border-radius: 50%
      background: rgb(5, 101, 222)
      margin 0 5px
      .trans-icon
        position: absolute
        left 50%
        top 50%
        transform: translate(-50%,-50%)
        display: inline-block
        width 14px
        height: 14px
        cursor pointer
        bg-image('~@/icon/trans.png')
    .speed-to-icon
      cursor pointer
      margin 0 5px
      bg-image('~@/icon/speed-to.png')
    .speed-back-icon
      cursor pointer
      margin 0 5px
      bg-image('~@/icon/speed-back.png')
    .resolution
      margin-left 20px
      .resolution-low
        cursor pointer
        padding 2px 6px
        border-bottom-left-radius 8px
        border-top-left-radius 8px
        border 1px solid #D4D4D4
      .resolution-hight
        cursor pointer
        padding 2px 6px
        border 1px solid #D4D4D4
        border-bottom-right-radius 8px
        border-top-right-radius 8px
      .hightLight
        background: var(--video-resolution-bg);
        color: var(--hisvideo-resolution-color);
  .video-play-contain
    height calc(100% - 56px)
    .video-player
      width 100%
      height 100%
      object-fit fill
    .play-tip
      position absolute
      left 50%
      top 50%
      transform translate(-50%, -50%)
      color #fff
.video-info-table
  border-collapse: collapse;
  .video-info-td25
    width: 25%;
  .video-info-td100
    width: 100%;
  .video-info-title
    text-align: center;
    font-weight: bold;
  .video-info-td
    border: 1px solid #000000;
    padding: 0 0 0 3px;

// 深色样式
.theme-dark
  .video-play-main
    background-color: #415a89;
  .video-play-title
    .name
      color #fff
</style>
